import i18n from '.';

/* Libellés du menu latéral. Ils viennent de la base (table entree_menu, servie par
   /v1/navigation) : en français, c'est TOUJOURS le libellé de la base, comme avant —
   un renommage fait en base reste visible. En anglais, la traduction de la clé
   (locales/en/menu.json), sinon le libellé de la base : une entrée ajoutée plus tard
   sans traduction reste lisible. */

const anglais = (bloc) => {
  if (i18n.language !== 'en') return null;
  const valeurs = i18n.getResourceBundle('en', 'menu')?.[bloc];
  return valeurs && typeof valeurs === 'object' ? valeurs : null;
};

/** Libellé d'une entrée de /v1/navigation ({ cle, libelle }). */
export const libelleMenu = (entree) => anglais('entrees')?.[entree?.cle] || entree?.libelle || entree?.libelleMenu;

/** Libellé d'une section, désignée par son nom français tel qu'en base. */
export const libelleSection = (section) => anglais('sections')?.[section] || section;
